export default __webpack_public_path__ + "static/icon-light-weight-8ab44a418d7abf802d55de2ccf8e7e8b.webp";